import { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  ListItemText,
  ListItemIcon
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { changeAppLanguage, SupportedLanguage } from '../../i18n';

const LANGUAGES: { code: SupportedLanguage; labelKey: string; flag: string }[] = [
  { code: 'ua', labelKey: 'common.languageUk', flag: '🇺🇦' },
  { code: 'en', labelKey: 'common.languageEn', flag: '🇬🇧' }
];

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const current = (i18n.resolvedLanguage || i18n.language || 'ua').slice(0, 2) as SupportedLanguage;
  const currentItem = LANGUAGES.find(l => l.code === current) || LANGUAGES[0];

  return (
    <>
      <Tooltip title={t('common.language')}>
        <IconButton
          size='small'
          onClick={(e) => setAnchor(e.currentTarget)}
          sx={{
            color: 'text.primary',
            '&:hover': { backgroundColor: 'rgba(78, 205, 196, 0.08)' }
          }}
        >
          <span style={{ fontSize: 18, lineHeight: 1 }} aria-hidden>
            {currentItem.flag}
          </span>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {LANGUAGES.map(lang => (
          <MenuItem
            key={lang.code}
            selected={lang.code === current}
            onClick={() => {
              changeAppLanguage(lang.code);
              setAnchor(null);
            }}
            sx={{ minWidth: 160 }}
          >
            <ListItemIcon sx={{ minWidth: 28 }}>
              <span style={{ fontSize: 18 }} aria-hidden>{lang.flag}</span>
            </ListItemIcon>
            <ListItemText primary={t(lang.labelKey)} />
            {lang.code === current && (
              <CheckIcon fontSize='small' sx={{ ml: 1, color: 'primary.main' }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
